import InnerHTML from "dangerously-set-html-content";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Description } from "./Description";

interface OptionDescriptionProps {
  accessDesc: string;
  isAccessOpen?: boolean;
  isVisibilityOpen?: boolean;
  lockScreenDesc?: string;
  visibilityDesc: string;
}
export const OptionDescription = ({
  accessDesc,
  visibilityDesc,
  lockScreenDesc,
  isAccessOpen = false,
  isVisibilityOpen = true,
}: OptionDescriptionProps) => (
  <div
    className="mt-3 grid gap-2 text-left text-sm"
    style={{
      gridTemplateColumns: "min-content auto",
    }}
  >
    <Icon
      type={isAccessOpen ? "16-lock-unlocked" : "16-lock"}
      size={16}
      className="text-default mt-px !self-start"
    />
    <Description title={t("customize_space.access")}>{accessDesc}</Description>
    <Icon
      type={isVisibilityOpen ? "16-eye-visible" : "16-eye-hidden"}
      size={16}
      className="text-default mt-px !self-start"
    />
    <Description title={t("customize_space.visibility")}>
      {visibilityDesc}
    </Description>
    {lockScreenDesc && (
      <>
        <Icon
          type="16-document-text"
          size={16}
          className="text-default mt-px !self-start"
        />
        <Description title={t("customize_space.lock_screen_page")}>
          <InnerHTML html={lockScreenDesc} />
        </Description>
      </>
    )}
  </div>
);
